import { render, staticRenderFns } from "./SiteAssetsComponent.vue?vue&type=template&id=552634d9&"
import script from "./SiteAssetsComponent.vue?vue&type=script&lang=js&"
export * from "./SiteAssetsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports